export default (state = { videoTime: 0, counter: 0 }, action) => {
    switch (action.type) {
        case 'INCREMENT':
            return { ...state, counter: state.counter + 1 }
        case 'UPDATE_VIDEO_TIME':
            return { ...state, videoTime: action.videoTime }
        default:
            return state
    }
}